import { Close } from '@mui/icons-material';
import { Box, BoxProps, IconButton, Typography } from '@mui/material';
import clsx from 'clsx';
import React, { memo } from 'react';
import style from './index.module.scss';

interface Props extends Omit<BoxProps, 'title'> {
  title?: React.ReactNode;
  onClose?: () => void;
}

export const AppDialogTitle = memo<Props>(({ children, onClose, title, className, ...rest }) => {
  return (
    <Box className={clsx(style.root, className)} {...rest}>
      <Typography variant={'h2'} component={'h2'} color={'primary'}>
        {title}
      </Typography>
      {onClose && (
        <IconButton className={style.close} onClick={onClose} color={'primary'}>
          <Close color={'inherit'} />
        </IconButton>
      )}
      {children}
    </Box>
  );
});
